import React from "react";
import { Link, Outlet, NavLink } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      {/* subtle background glow */}
      <div className="pointer-events-none fixed inset-0 opacity-70">
        <div className="absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute top-40 right-[-120px] h-[420px] w-[420px] rounded-full bg-fuchsia-500/15 blur-3xl" />
        <div className="absolute bottom-[-180px] left-[-120px] h-[520px] w-[520px] rounded-full bg-emerald-500/10 blur-3xl" />
      </div>

      <header className="relative z-10">
        <div className="mx-auto max-w-6xl px-4 pt-6">
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_25px_70px_rgba(0,0,0,0.35)]">
            <div className="flex items-center justify-between gap-4 px-5 py-4 md:px-7">
              <Link to="/" className="flex items-center gap-3">

                <div className="leading-tight">
                  <div className="text-base font-semibold tracking-wide">AM Rental</div>
                </div>
              </Link>

              <div className="hidden items-center gap-6 md:flex">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `text-sm font-medium transition ${
                      isActive ? "text-white" : "text-white/70 hover:text-white"
                    }`
                  }
                >
                  Начало
                </NavLink>
                <a
                  href="tel:+359999991948"
                  className="inline-flex items-center gap-2 rounded-2xl bg-white/10 px-4 py-2 text-sm font-semibold ring-1 ring-white/15 hover:bg-white/15 transition"
                >
                  <span className="inline-block h-2 w-2 rounded-full bg-emerald-400" />
                  +359 999 99 1948
                </a>
              </div>

              <a
                href="tel:+359999991948"
                className="md:hidden inline-flex items-center gap-2 rounded-2xl bg-white/10 px-4 py-2 text-sm font-semibold ring-1 ring-white/15 hover:bg-white/15 transition"
              >
                <span className="inline-block h-2 w-2 rounded-full bg-emerald-400" />
                Обади се
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10">
        <Outlet />
      </main>

      <footer className="relative z-10 mt-16">
        <div className="mx-auto max-w-6xl px-4 pb-10">
            <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl">
                <div className="grid gap-6 px-5 py-6 md:grid-cols-3 md:items-start md:px-7">
                    {/* Contacts */}
                    <div>
                    <div className="text-sm text-white/60">Контакти</div>
                    <a
                        href="tel:+359999991948"
                        className="mt-1 inline-flex items-center gap-2 text-base font-semibold hover:underline"
                    >
                        +359 999 99 1948
                    </a>
                    </div>

                    {/* Address */}
                    <div>
                    <div className="text-sm text-white/60">Адрес</div>
                    <div className="mt-1 text-sm text-white/80 leading-relaxed">
                        София, България<br />
                        рн. Средец<br />
                        Иван Вазов 38, ет. 3<br />
                    </div>
                    </div>

                    {/* Links + copyright */}
                    <div className="md:text-right">
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm md:justify-end">
                        <a href="/privacy" className="text-white/70 hover:text-white">
                        Privacy Policy
                        </a>
                        <a href="/conditions" className="text-white/70 hover:text-white">
                        Conditions of use
                        </a>
                    </div>
                    <div className="mt-3 text-xs text-white/50">
                        © {new Date().getFullYear()} AM Rental
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </footer>

    </div>
  );
}
